
import CloseIcon from '@mui/icons-material/Close'
import DescriptionIcon from '@mui/icons-material/Description'
import { alpha, Box, Grid, IconButton, Tooltip, useTheme } from '@mui/material'
import React from 'react'
import PictureAsPdfIcon from '../../images/icons/PDF_file_icon.svg'

// Helper function that returns either an image preview or a representative icon.
// const getFileThumbnail = (file: File): JSX.Element => {
//   if (file.type.startsWith('image/')) {
//     return (
//       <Box
//         component='img'
//         src={URL.createObjectURL(file)}
//         alt='file preview'
//         sx={{
//           width: '100%',
//           height: 40,
//           objectFit: 'cover',
//           borderRadius: 1,
//         }}
//       />
//     )
//   } else if (file.type === 'application/pdf') {
//     // return <PictureAsPdfIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
//     return <img src={PictureAsPdfIcon} alt='taskPdfIcon' style={{ height: 40, width: 40, objectFit: 'cover' }} />
//   } else if (file.name.match(/\.(doc|docx)$/i)) {
//     return <DescriptionIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
//   } else {
//     return <DescriptionIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
//   }
// }
const getFileThumbnail = (file: any, size: number): JSX.Element => {
  const imageSrc =
    file.previewUrl || file.thumbnailLink || file.iconLink || (file.url?.startsWith('blob:') ? file.url : null)

  if (file.mimeType?.startsWith('image/') && imageSrc) {
    return (
      <Box
        component="img"
        src={imageSrc}
        alt="preview"
        sx={{ width: '100%', height: size ?? 40, objectFit: 'cover', borderRadius: 1 }}
      />
    )
  } else if (file.mimeType === 'application/pdf') {
    return (
      <img
        src={PictureAsPdfIcon}
        alt="PDF Icon"
        style={{ height: size ?? 40, width: size ?? 40, objectFit: 'cover' }}
      />
    )
  } else if (file.name?.match(/\.(doc|docx)$/i)) {
    return <DescriptionIcon sx={{ fontSize: size ?? 40, color: 'text.secondary' }} />
  } else {
    return <DescriptionIcon sx={{ fontSize: size ?? 40, color: 'text.secondary' }} />
  }
}

// interface NewFileAttachmentsProps {
//   selectedFiles: File[]
//   onRemoveFile: (index: number) => void
// }
interface NewFileAttachmentsProps {
  selectedFiles: {
    id: string
    name: string
    mimeType?: string
    previewUrl?: string
    thumbnailLink?: string
    iconLink?: string
    file?: File
    url?: string
  }[]
  onRemoveFile: (index: number) => void
  size: number
}

export const NewFileAttachments: React.FC<NewFileAttachmentsProps> = ({ selectedFiles, onRemoveFile, size }) => {
  const theme = useTheme()
  return (
    <Grid
      container
      sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {selectedFiles.map((file, index) => {
        return (
          <Grid item key={index}>
            {/* <Box key={index} sx={{ position: 'relative', width: 'auto', height: 'auto' }}> */}
            <Tooltip title={file.name}>
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  cursor: 'pointer',
                  position: 'relative',
                  '&:hover .overlay': { opacity: 1 },
                  alignItems: 'center',
                }}
              >
                {getFileThumbnail(file, size)}
                {/* Overlay with delete icon */}
                <Box
                  className="overlay"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: alpha(theme.palette.text.primary, 0.4),
                    opacity: 0,
                    transition: 'opacity 0.2s',
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={e => {
                      e.stopPropagation()
                      onRemoveFile(index)
                    }}
                    sx={{
                      color: theme.palette.background.default,
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            </Tooltip>
          </Grid>
        )
      })}
    </Grid>
  )
}
